// ============================================
// MAIN INIT - Carica tutto con event delegation
// ============================================
(function () {
    'use strict';

    // Singolo container per TUTTA l'event delegation
    const container = document.body;

    // ============================================
    // DROPDOWN
    // ============================================
    const dropdownState = {
        current: {
            menu: null,
            toggle: null
        },

        closeAll: () => {
            document.querySelectorAll('[data-dropdown-toggle]').forEach(t =>
                t.setAttribute('aria-expanded', 'false')
            );
            document.querySelectorAll('[data-dropdown-menu]').forEach(m =>
                m.classList.remove('is-open', 'open-up', 'open-down')
            );
            dropdownState.current = {
                menu: null,
                toggle: null
            };
        },

        position: (toggle, menu) => {
            menu.classList.remove('open-up', 'open-down');
            const toggleRect = toggle.getBoundingClientRect();
            const menuRect = menu.getBoundingClientRect();
            const spaceBelow = window.innerHeight - toggleRect.bottom;
            const spaceAbove = toggleRect.top;

            if (spaceBelow < menuRect.height && spaceAbove > menuRect.height) {
                menu.classList.add('open-up');
                menu.style.top = `${toggle.offsetTop - menu.offsetHeight - 4}px`;
            } else {
                menu.classList.add('open-down');
                menu.style.top = `${toggle.offsetTop + toggle.offsetHeight + 4}px`;
            }
            //menu.style.left = `${toggle.offsetLeft}px`;
        },

        open: (toggle, menu, focusFirst = false) => {
            const items = Array.from(menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'));
            toggle.setAttribute('aria-expanded', 'true');
            menu.classList.add('is-open');
            dropdownState.position(toggle, menu);
            if (focusFirst && items[0]) items[0].focus();
            dropdownState.current = {
                menu,
                toggle
            };
        }
    };

    // ============================================
    // DUAL RANGE
    // ============================================
    const dualRangeState = {
        fillColor: (wrapper) => {
            const track = wrapper.querySelector('.slider-track');
            if (!track) return;

            const ranges = wrapper.querySelectorAll('input[type="range"]');
            if (ranges.length < 2) return;

            const [one, two] = ranges;
            const max = sanitize.number(one.max, 100, 0, 10000);
            const min = sanitize.number(one.min, 0, 0, 10000);

           const valueOne = sanitize.number(one.value, min, min, max);    
           const valueTwo = sanitize.number(two.value, max, min, max);

            const p1 = ((valueOne - min) / (max - min)) * 100;
            const p2 = ((valueTwo - min) / (max - min)) * 100;
           
            const active = getComputedStyle(wrapper).getPropertyValue('--slider-color')?.trim() || '#3264fe';
            const base = getComputedStyle(wrapper).getPropertyValue('--slider-base-color')?.trim() || '#dadae5';

            track.style.background = `linear-gradient(to right, ${base} ${p1}%, ${active} ${p1}%, ${active} ${p2}%, ${base} ${p2}%)`;
        },

        update: (slider, wrapper) => {
            dualRangeState.fillColor(wrapper);
            if (!wrapper.hasAttribute('update-labels')) return;
            const ranges = wrapper.querySelectorAll('input[type="range"]');
            if (ranges.length < 2) return;

            const [one, two] = ranges;
            const minGap = sanitize.integer(wrapper.dataset.minGap, 0, 0, 1000);
            const isFirst = slider === one;
            const display = wrapper.querySelector(`.slider-values span:${isFirst ? 'first' : 'last'}-child`);

            if (isFirst) {
                const valueOne = sanitize.integer(one.value, 0);
                const valueTwo = sanitize.integer(two.value, 0);
                if (valueTwo - valueOne <= minGap) {
                    one.value = valueTwo - minGap;
                }
            } else {
                const valueOne = sanitize.integer(one.value, 0);
                const valueTwo = sanitize.integer(two.value, 0);
                if (valueTwo - valueOne <= minGap) {
                    two.value = valueOne + minGap;
                }
            }

            if (display) display.textContent = slider.value;
            
        },

        initAll: () => {
            document.querySelectorAll('.dual-range-wrapper').forEach(wrapper => {
                const ranges = wrapper.querySelectorAll('input[type="range"]');
                if (ranges.length < 2) return;
                ranges.forEach(slider => {
                    slider.addEventListener('input', () => dualRangeState.update(slider, wrapper));
                });

                dualRangeState.update(ranges[0], wrapper);
                dualRangeState.update(ranges[1], wrapper);
            });
        }
    };

    // ============================================
    // VIDEO PLAYER
    // ============================================
    const videoState = {
        // Whitelist di domini sicuri
        ALLOWED_DOMAINS: {
            youtube: ['youtube.com', 'www.youtube.com', 'youtu.be'],
            vimeo: ['vimeo.com', 'www.vimeo.com'],
            html5: [] // Configurabile se necessario
        },

        // Lunghezza massima URL per prevenire ReDoS
        MAX_URL_LENGTH: 2048,

        // Valida URL contro whitelist
        isValidUrl: (url, type) => {
            try {
                // Limita lunghezza per prevenire ReDoS
                if (!url || url.length > videoState.MAX_URL_LENGTH) return false;
                
                const urlObj = new URL(url);
                const allowedDomains = videoState.ALLOWED_DOMAINS[type];
                
                if (!allowedDomains || allowedDomains.length === 0) return true;
                
                return allowedDomains.some(domain => 
                    urlObj.hostname === domain || urlObj.hostname.endsWith('.' + domain)
                );
            } catch {
                return false;
            }
        },

        // Sanitizza e valida YouTube ID
        getYouTubeId: (url) => {
            if (!videoState.isValidUrl(url, 'youtube')) return null;
            
            // Regex semplificata e sicura con limite lunghezza già applicato
            const regExp = /(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(regExp);
            return match ? match[1] : null;
        },

        // Sanitizza e valida Vimeo ID
        getVimeoId: (url) => {
            if (!videoState.isValidUrl(url, 'vimeo')) return null;
            
            // Regex semplificata con limite lunghezza già applicato
            const regExp = /vimeo\.com\/(\d{6,12})/;
            const match = url.match(regExp);
            return match ? match[1] : null;
        },

        getVideoType: (url) => {
            if (!url || url.length > videoState.MAX_URL_LENGTH) return null;
            
            if (url.includes('youtube.com') || url.includes('youtu.be')) {
                return 'youtube';
            } else if (url.includes('vimeo.com')) {
                return 'vimeo';
            } else if (/\.(mp4|webm|ogg)$/i.test(url)) {
                return 'html5';
            }
            return null;
        },

        createYouTubePlayer: (videoId, container) => {
            // Valida formato YouTube ID (11 caratteri alfanumerici, underscore, trattino)
            if (!/^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
                log.error('ID YouTube non valido');
                return;
            }
            
            const iframe = document.createElement('iframe');
            // Usa encodeURIComponent per sicurezza extra
            iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.frameBorder = '0';
            iframe.allow = 'autoplay; encrypted-media';
            iframe.allowFullscreen = true;
            iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';
            container.appendChild(iframe);
        },

        createVimeoPlayer: (videoId, container) => {
            // Valida formato Vimeo ID (6-12 cifre)
            if (!/^\d{6,12}$/.test(videoId)) {
                log.error('ID Vimeo non valido');
                return;
            }
            
            const iframe = document.createElement('iframe');
            iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1`;
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.frameBorder = '0';
            iframe.allow = 'autoplay; fullscreen; picture-in-picture';
            iframe.allowFullscreen = true;
            iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';
            container.appendChild(iframe);
        },

        createHTML5Player: (videoUrl, container) => {
            // Valida che l'URL abbia estensione video valida
            if (!/\.(mp4|webm|ogg)$/i.test(videoUrl)) {
                log.error('Formato video HTML5 non valido');
                return;
            }
            
            const video = document.createElement('video');
            video.src = videoUrl;
            video.controls = true;
            video.autoplay = true;
            video.style.cssText = 'width:100%;height:100%;object-fit:cover;';
            container.appendChild(video);
        },

        loadVideo: (link) => {
            try {
                const videoUrl = link.getAttribute('href');
                if (!videoUrl) return;

                const videoType = videoState.getVideoType(videoUrl);
                const container = link.closest('.item-media');
                if (!container) return;

                // Rimuovi il contenuto esistente in modo sicuro (no innerHTML)
                while (container.firstChild) {
                    container.removeChild(container.firstChild);
                }
                container.style.position = 'relative';

                // Crea il player appropriato
                switch(videoType) {
                    case 'youtube':
                        const youtubeId = videoState.getYouTubeId(videoUrl);
                        if (youtubeId) {
                            videoState.createYouTubePlayer(youtubeId, container);
                        } else {
                            log.error('URL YouTube non valido o non sicuro');
                        }
                        break;

                    case 'vimeo':
                        const vimeoId = videoState.getVimeoId(videoUrl);
                        if (vimeoId) {
                            videoState.createVimeoPlayer(vimeoId, container);
                        } else {
                            log.error('URL Vimeo non valido o non sicuro');
                        }
                        break;

                    case 'html5':
                        if (videoState.isValidUrl(videoUrl, 'html5')) {
                            videoState.createHTML5Player(videoUrl, container);
                        } else {
                            log.error('URL video HTML5 non valido o non sicuro');
                        }
                        break;

                    default:
                        log.error('Tipo di video non riconosciuto o non supportato');
                }
            } catch (error) {
                log.error('Errore durante il caricamento del video:', error.message);
            }
        }
    };

    // ============================================
    // UTILITY - SANITIZZAZIONE
    // ============================================
    const sanitize = {
        // Sanitizza attributo ID per usarlo nei selettori CSS
        cssSelector: (id) => {
            if (!id || typeof id !== 'string') return null;
            // Rimuovi caratteri pericolosi per i selettori CSS
            return id.replace(/[^a-zA-Z0-9_-]/g, '');
        },
        
        // Limita lunghezza testo per prevenire overflow
        text: (text, maxLength = 500) => {
            if (!text || typeof text !== 'string') return '';
            return text.trim().slice(0, maxLength);
        },
        
        // Valida e sanitizza numero
        number: (value, defaultValue = 0, min = -Infinity, max = Infinity) => {
            const num = parseFloat(value);
            if (isNaN(num) || !isFinite(num)) return defaultValue;
            return Math.max(min, Math.min(max, num));
        },
        
        // Valida e sanitizza intero
        integer: (value, defaultValue = 0, min = -Infinity, max = Infinity) => {
            const num = parseInt(value, 10);
            if (isNaN(num) || !isFinite(num)) return defaultValue;
            return Math.max(min, Math.min(max, num));
        },
        
        // Protezione Prototype Pollution
        config: (config, allowedKeys) => {
            if (!config || typeof config !== 'object') return {};
            
            const safe = {};
            const dangerous = ['__proto__', 'constructor', 'prototype'];
            
            for (const key in config) {
                if (dangerous.includes(key)) continue;
                if (!Object.prototype.hasOwnProperty.call(config, key)) continue;
                if (allowedKeys && !allowedKeys.includes(key)) continue;
                
                const value = config[key];
                if (typeof value === 'object' && value !== null) {
                    safe[key] = Array.isArray(value) ? [...value] : { ...value };
                } else {
                    safe[key] = value;
                }
            }
            
            return safe;
        }
    };

    // ============================================
    // SELECT FLOATING LABEL
    // ============================================
    const selectLabel = (element) => {
        try {
            // Valida e sanitizza l'ID prima di usarlo nel selettore
            const safeId = sanitize.cssSelector(element.id);
            if (!safeId) return;
            
            const label = document.querySelector(`label[for="${safeId}"]`);
            if (label) {
                if (element.value === "") {
                    label.classList.add("d-none");
                    element.classList.remove("ae-selected");
                } else {
                    label.classList.remove("d-none");
                    element.classList.add("ae-selected");
                }
            }
        } catch (error) {
            log.error('Errore in selectLabel:', error.message);
        }
    };

    const handleFloatingLabel = (event) => {
        const target = event.target;
        if (target.classList.contains("form-select")) {
            selectLabel(target);
        }
    };

    const initFloatingLabels = () => {
        try {
            document.querySelectorAll(".form-select").forEach(select => {
                selectLabel(select);
            });

            addEventListenerTracked(container, "change", handleFloatingLabel);
        } catch (error) {
            log.error('Errore in initFloatingLabels:', error.message);
        }
    };

    // ============================================
    // EVENT DELEGATION UNIFICATA
    // ============================================
    function setupEventDelegation() {
        // CLICK - gestisce dropdown, video, details
        addEventListenerTracked(container, 'click', (e) => {

            // Video player
            const videoLink = e.target.closest('.item-video');
            if (videoLink) {
                e.preventDefault();
                videoState.loadVideo(videoLink);
                return;
            }

            // Dropdown toggle
            const dropdownToggle = e.target.closest('[data-dropdown-toggle]');
            if (dropdownToggle) {
                e.preventDefault();
                const id = sanitize.cssSelector(dropdownToggle.getAttribute('data-dropdown-toggle'));
                if (!id) return;
                
                const menu = document.querySelector(`[data-dropdown-menu="${id}"]`);
                if (!menu) return;

                const isOpen = dropdownToggle.getAttribute('aria-expanded') === 'true';
                dropdownState.closeAll();
                if (!isOpen) dropdownState.open(dropdownToggle, menu, e.detail === 0);
                return;
            }

            // Click fuori dropdown
            if (!e.target.closest('[data-dropdown-menu]')) {
                dropdownState.closeAll();
            }

            const submenuItem = e.target.closest('[close-on-click]');
            if (submenuItem) {
                 dropdownState.closeAll();
                const menu = submenuItem.closest('[data-dropdown-menu]');
                const id = sanitize.cssSelector(menu?.getAttribute('data-dropdown-menu'));
                if (!id) return;
                
                const parent = document.querySelector(`[data-dropdown-toggle="${id}"]`);

                if (parent && parent.hasAttribute('show-selected-text')) {
                    // Sanitizza il testo prima di assegnarlo (max 200 caratteri)
                    const safeText = sanitize.text(submenuItem.textContent, 200);
                    parent.textContent = safeText;
                }
            }

             //details open/close effect
              const summary =  e.target.closest('summary'); 
              if (summary) {
                e.preventDefault();
                const details = summary.parentElement;
                details.classList.toggle('show-content');
                const textOpened = sanitize.text(details.getAttribute('data-text-opened'), 200);
                const textClosed = sanitize.text(details.getAttribute('data-text-closed'), 200);
                if (textOpened && textClosed) {
                    const span = summary.querySelector("span");
                    if (span) {
                        span.textContent = details.classList.contains('show-content') ? textOpened : textClosed;
                    }
                }
                const content = details.querySelector('.content');
                if (!details.open) {
                    // Apertura: cancella eventuali timeout pendenti
                    if (detailsTimeouts.has(details)) {
                        clearTimeout(detailsTimeouts.get(details));
                        detailsTimeouts.delete(details);
                    }
                    
                    details.open = true;                
                    requestAnimationFrame(() => {
                        content.style.maxHeight = content.scrollHeight + 'px';
                        content.style.opacity = '1';
                    });
                } else {
                    // Chiusura
                    content.style.maxHeight = '0';
                    content.style.opacity = '0';
                    
                    // Cancella timeout precedente se esiste
                    if (detailsTimeouts.has(details)) {
                        clearTimeout(detailsTimeouts.get(details));
                    }
                    
                    const timeout = setTimeout(() => {
                        details.open = false;
                        detailsTimeouts.delete(details);
                    }, 400);
                    
                    detailsTimeouts.set(details, timeout);
                }

                // Gestione accordion
                const groupName = sanitize.cssSelector(details.getAttribute('name'));
                if (groupName) {
                    document.querySelectorAll(`details[name="${groupName}"]`).forEach(d => {
                        if (d !== details) {
                            // Cancella timeout pendente
                            if (detailsTimeouts.has(d)) {
                                clearTimeout(detailsTimeouts.get(d));
                            }
                            
                            d.classList.remove('show-content');
                            const dContent = d.querySelector('.content');
                            dContent.style.maxHeight = '0';
                            dContent.style.opacity = '0';   
                            
                            const timeout = setTimeout(() => {
                                d.open = false;
                                detailsTimeouts.delete(d);
                            }, 400);
                            
                            detailsTimeouts.set(d, timeout);
                        }       
                    });
                }
            }
        });

        // TOUCHSTART - dropdown mobile
        addEventListenerTracked(container, 'touchstart', (e) => {
            const inToggle = e.target.closest('[data-dropdown-toggle]');
            const inMenu = e.target.closest('[data-dropdown-menu]');
            if (!inToggle && !inMenu) dropdownState.closeAll();
        });

        // KEYDOWN - gestisce dropdown
        addEventListenerTracked(container, 'keydown', (e) => {
            // Dropdown toggle
            const dropdownToggle = e.target.closest('[data-dropdown-toggle]');
            if (dropdownToggle && !e.target.closest('[data-dropdown-menu]')) {
                if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    dropdownToggle.click();
                }
            }

            // Dropdown menu
            const dropdownMenu = e.target.closest('[data-dropdown-menu]');
            if (dropdownMenu) {
                const items = Array.from(dropdownMenu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'));
                const idx = items.indexOf(document.activeElement);

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    items[(idx + 1) % items.length]?.focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    items[(idx - 1 + items.length) % items.length]?.focus();
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    dropdownState.closeAll();
                    dropdownState.current.toggle?.focus();
                } else if (e.key === 'Tab') {
                    dropdownState.closeAll();
                }
            }
        });

        // INPUT - dual range
        addEventListenerTracked(container, 'input', (e) => {
            if (e.target.type === 'range') {
                const wrapper = e.target.closest('.dual-range-wrapper');
                if (wrapper) dualRangeState.update(e.target, wrapper);
            }
        });
    }

    // ============================================
    // LOGGING UTILITY (solo in dev mode)
    // ============================================
    const IS_DEV = typeof window !== 'undefined' && 
                   (window.location?.hostname === 'localhost' || 
                    window.location?.hostname === '127.0.0.1' ||
                    window.location?.protocol === 'file:');
    
    const log = {
        info: (message, ...args) => IS_DEV && console.log(message, ...args),
        error: (message, ...args) => console.error(message, ...args) // Gli errori sempre visibili
    };

    // ============================================
    // CLEANUP & MEMORY MANAGEMENT
    // ============================================
    const eventListeners = [];
    let mutationObserver = null;
    let mutationObserverTimeout = null;
    let resizeTimeout = null;
    const detailsTimeouts = new Map(); // Gestione timeout per details
    
    function addEventListenerTracked(element, event, handler, options) {
        element.addEventListener(event, handler, options);
        eventListeners.push({ element, event, handler, options });
    }

    // ============================================
    // VIEWPORT HEIGHT FIX (for mobile browsers)
    // ============================================
    function setViewportHeight() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    // ============================================
    // INIT PRINCIPALE
    // ============================================
    function initAll() {
        dualRangeState.initAll();
        setupEventDelegation();
        initFloatingLabels();
        setViewportHeight();
        
        // Update viewport height on resize (throttled)
        addEventListenerTracked(window, 'resize', () => {
            if (resizeTimeout) clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(setViewportHeight, 150);
        });
        
        log.info('UI initialized - Version 1.7.0');
    }

    // ============================================
    // AUTO-INIT E EXPORT
    // ============================================
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    // API pubblica
    window.initUI = {
        init: initAll,
        refresh: () => {
            dualRangeState.initAll();
        },
        destroy: () => {
            // Rimuovi tutti gli event listener tracciati
            eventListeners.forEach(({ element, event, handler, options }) => {
                element.removeEventListener(event, handler, options);
            });
            eventListeners.length = 0;
            
            // Disconnetti MutationObserver
            if (mutationObserver) {
                mutationObserver.disconnect();
                mutationObserver = null;
            }
            
            // Cancella timeout pendenti
            if (mutationObserverTimeout) {
                clearTimeout(mutationObserverTimeout);
                mutationObserverTimeout = null;
            }
            
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
                resizeTimeout = null;
            }
            
            // Cancella tutti i timeout di details
            detailsTimeouts.forEach(timeout => clearTimeout(timeout));
            detailsTimeouts.clear();
            
            log.info('UI destroyed and cleaned up');
        },
        dropdown: dropdownState,
        dualRange: dualRangeState,
        video: videoState
    };



    // ============================================
    // MUTATION OBSERVER CON THROTTLING (prevenzione DoS)
    // ============================================
    if (typeof MutationObserver !== 'undefined') {
        let pendingMutations = [];
        
        mutationObserver = new MutationObserver((mutations) => {
            // Accumula mutazioni
            pendingMutations.push(...mutations);
            
            // Throttle: processa max ogni 250ms
            if (!mutationObserverTimeout) {
                mutationObserverTimeout = setTimeout(() => {
                    const mutationsToProcess = pendingMutations.slice();
                    pendingMutations = [];
                    mutationObserverTimeout = null;
                    
                    // Processa tutte le mutazioni accumulate
                    mutationsToProcess.forEach((mutation) => {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1) {
                                if (node.classList?.contains('dual-range') || node.querySelector?.('.dual-range')) {
                                    log.info('New dual range detected');
                                    window.initUI.dualRange.initAll();
                                }
                                if (node.matches?.('.form-select')) {
                                    selectLabel(node);
                                } else {
                                    node.querySelectorAll?.('.form-select').forEach(select => {
                                        selectLabel(select);
                                    });
                                }
                            }
                        });
                    });
                }, 250); // Throttle 250ms
            }
        });

        mutationObserver.observe(document.body, { childList: true, subtree: true });
    }
})();
